import BaseApi from "../../BaseApi";

export default abstract class BaseProjectApi extends BaseApi {
	protected override getBaseUrl(params: Record<string, string> = {}): string {
		return `${super.getBaseUrl(params)}/projects`;
	}
}
